import {
  CostCenterQuery,
  CostCentersConfigurationsQuery,
  CostCentersDistributionQuery,
  CostCentersListQuery,
  CostCentersOptionsQuery,
  CostCentersStructureQuery,
} from 'generated/resources/graphql'

import {
  FormattedAssignment,
  FormattedAssignmentWithDeletion,
} from 'modules/finance/lib/costCenterAssignments'

export interface AllocationSelectOption {
  label: string
  value: string
  resourceId?: string
}

export const LINKABLE_RESOURCES: Record<AssignmentResourceKeys, AssignmentResourceKeys> = {
  Employee: 'Employee',
} as const

export interface AllocationOption {
  label: string
  resourceType: AssignmentResourceKeys
  resourceId: string
}

export type AssignmentsOptions = CostCentersOptionsQuery['costCenters']
export type AssignmentResourceKeys = keyof Omit<AssignmentsOptions, '__typename'>

export interface AssignmentsChange {
  assignmentsToCreate: Omit<FormattedAssignment, 'id' | 'name'>[]
  assignmentsToUpdate: (Omit<FormattedAssignmentWithDeletion, 'id' | 'name'> & { id: string })[]
}

export interface AllocationReference {
  id?: string
  referenceType: string
  referenceId: string
}

export type CostCenter =
  CostCenterQuery['costCenters']['costCentersConnection']['edges'][number]['node']
export type ResourceDistribution =
  CostCentersDistributionQuery['costCenters']['distributionsConnection']['nodes']

export type CostCenterDetails =
  CostCentersListQuery['costCenters']['costCentersConnection']['edges'][number]['node']

export type CostCenterConfigurations =
  CostCentersConfigurationsQuery['costCenters']['configurationsConnection']['nodes']

export type JobCatalogStructures =
  CostCentersStructureQuery['jobCatalog']['treesConnection']['nodes']
